import { Chip } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createNotification } from 'react-redux-notify'

import { useQRCodeModal } from '../../../../hooks/useQRCodeModal'
import { formatTransactiontDate } from '../../../../helpers/date/date'
import WalletService from '../../../../helpers/services/payment/wallet'
import { fetchWalletHistoryStart } from '../../../../store/actions/WalletAction'
import { parsePaymentServiceError } from '../../../../helpers/services/payment/error'
import { getErrorNotificationMessage } from '../../../../components/helper/NotificationMessage'

import './styles/cards.css'
import NothingHere from '../../../../images_new/icon/nothing_here.svg?react'

export default function ChargesCard() {
  const dispatch = useDispatch()
  const { showQRCodeModal, QRCodeModal } = useQRCodeModal()
  
  const walletHistory = useSelector((state) => state.wallet.walletHistory)
  
  useEffect(() => {
    dispatch(fetchWalletHistoryStart())
  }, [])

  const getStatusColor = (status) => {
    if (status === 'COMPLETED') return 'success'
    if (status === 'FAILED') return 'error'
    if (status === 'PENDING') return 'warning'
    return 'info'
  }

  const handlePendingClick = async (payment) => {
    try {
      const result = await WalletService.fetchCryptoHostedUrl(payment.user_wallet_payment_unique_id)
      if (result?.data) {
        showQRCodeModal(
          result.data.hosted_url,
          result.data.expires_at,
          payment.requested_amount_formatted,
          result.data.is_in_test_mode
        )
      }
    } catch (error) {
      const message = parsePaymentServiceError(error.response)
      dispatch(createNotification(getErrorNotificationMessage(message || 'Failed to fetch payment details')))
    }
  }

  return (
    <>
      <div className={`cards-container`}>
        {walletHistory?.data?.history?.length > 0 ? (
          walletHistory?.data?.history?.map((wallet, index) => {
            const isPending = wallet.payment_mode === "Crypto" && wallet.status_formatted === 'PENDING' 
            return(
            <div className={`statement-card ${index % 2 !== 0 ? 'bg-white' : ''}`}>
              <div className='statement-card-header justify-content-between gap-2'>
                <h1
                  className='statement-card-title'
                  dangerouslySetInnerHTML={{ __html: wallet.message }}
                ></h1>
                {isPending && 
                  <div>
                    <button
                      role={"button"}
                      className="statement-button"
                      aria-label="info"
                      onClick={() => isPending && handlePendingClick(wallet)}
                    >
                      Check Payment
                    </button>
                  </div>
                }
              </div>
              <div className='statement-card-body'>
                <div className='w-100 d-flex justify-content-between'>
                  <p className='statement-text-title'>Date & time</p>{' '}
                  <p className='statement-text-data'>
                    {formatTransactiontDate(wallet.paid_date)}
                  </p>
                </div>
                <div className='w-100 d-flex justify-content-between mt-1'>
                  <p className='statement-text-title'>Amount</p>{' '}
                  <p className='statement-text-data'> {wallet.requested_amount_formatted}</p>
                </div>
                <div className='w-100 d-flex justify-content-between mt-1'>
                  <p className='statement-text-title'>Status</p>{' '}
                  <div className='d-flex align-items-start justify-content-center gap-1'>
                    <Chip
                      label={wallet.status_formatted}
                      color={getStatusColor(wallet.status_formatted)}
                      size="small"
                      variant='outlined'
                      sx={{
                        borderRadius: '6px',
                      }}
                      style={{ cursor : isPending ? "pointer" : 'default'}}
                    />
                  </div>
                </div>
                <div className='w-100 d-flex justify-content-between mt-1'>
                  <p className='statement-text-title'>Fee</p>{' '}
                  <p className='statement-text-data'>{wallet.usage_type == 'wallet_load' ? wallet.processing_fee_formatted : wallet.admin_amount_formatted}</p>
                </div>
                <div className={`w-100 d-flex justify-content-between mt-1 `}>
                  <p className='statement-text-title'>Net</p>{' '}
                  <p className='statement-text-data'>{wallet.user_amount_formatted}</p>
                </div>
              </div>
            </div>
          )})
        ) : (
          <>
            <div className='d-flex w-100 justify-content-center mt-3'>
              <NothingHere />
            </div>
          </>
        )}
      </div>
      <QRCodeModal />
    </>
  )
}
